import { render, staticRenderFns } from "./ServiceDeposit.vue?vue&type=template&id=df9c25f2"
import script from "./ServiceDeposit.vue?vue&type=script&lang=js"
export * from "./ServiceDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports